import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClientConfigurationOptionDefinition } from '../../../core/models/client-configuration-option-definition.model';
import { ClientConfigurationOption } from '../../../core/models/client-configuration-option.model';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-client-configuration-disableable',
    templateUrl: './client-configuration-disableable.component.html',
    styleUrls: ['./client-configuration-disableable.component.scss'],
    imports: [MatSlideToggle, FormsModule]
})
export class ClientConfigurationDisableableComponent implements OnInit {
  @Input() definition: ClientConfigurationOptionDefinition;
  @Input() configOption: ClientConfigurationOption;

  @Output() enableChange: EventEmitter<any> = new EventEmitter<any>();

  enabled: boolean = false;

  constructor() {}

  ngOnInit() {
    this.enabled = this.configOption.disabledAt ? false : true;
  }

  onEnableChange($event: MatSlideToggleChange) {
    this.enabled = $event.checked
    this.enableChange.emit(this.enabled);
  }
}